<template>
    <div class="form-group">
        <div class="input-group">
            <input
                autocomplete="off"
                class="form-control"
                :disabled="disabled"
                id="exampleInputEmail1"
                @input="e => $emit('input', e.target.value)"
                placeholder="Enter email"
                type="email"
                :value="value"
            >
            <div class="input-group-append input-group-addon">
            <span
                class="input-group-text pointer"
                @click.prevent="() => $emit('clear')"
                id="inputGroupPrepend2"
            >
                Clear
            </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailInput',

    props: {
        disabled: {
            default: false,
            required: false,
            type: Boolean,
        },
        value: {
            required: true,
            type: String,
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Users/LoginOrSignup/Inputs/Email.vue